import {
   clsx
  ,Box
  ,Link
} from 'external/material'
import LinkBehavior from 'components/LinkBehavior'
import icons from 'resources/icons'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'

export default function Assignment({id, count, type, active, iconProps}) {
  const Icon = icons[type]
  const {translate} = useTranslations()
  const {navigation} = useSession()
  const to = navigation.section.link({section: type})
  return (<Link underline="none" component={LinkBehavior} to={to} className={clsx('assignment', type, {activeAssignment: active})}>
    <Box className={clsx('icon', type)}>
      <Icon {...(iconProps || {})}/>
    </Box>
    <Box className="countTypeName">{translate(`${type}-count-type`)}</Box>
    <Box className={clsx('count', type)}>
      {count}
    </Box>
  </Link>)
}
